import { render, staticRenderFns } from "./ResourceDownloadLink.vue?vue&type=template&id=5247f11f&"
import script from "./ResourceDownloadLink.vue?vue&type=script&lang=js&"
export * from "./ResourceDownloadLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports